// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var StudentTopNav__NavLink = require("../types/StudentTopNav__Types/StudentTopNav__NavLink.bs.js");

function str(prim) {
  return prim;
}

function handleToggle(setLinksVisible, param) {
  return Curry._1(setLinksVisible, (function (linksVisible) {
                return !linksVisible;
              }));
}

function additionalLinks(linksVisible, links) {
  if (linksVisible) {
    return React.createElement("div", {
                className: "dropdown__list dropdown__list-right bg-white shadow-lg rounded mt-3 border absolute w-40 z-50"
              }, $$Array.of_list(List.mapi((function (index, link) {
                          return React.createElement("div", {
                                      key: String(index),
                                      className: ""
                                    }, React.createElement("a", {
                                          className: "cursor-pointer block p-3 text-xs font-semibold text-gray-900 border-b border-gray-200 bg-white hover:text-primary-500 hover:bg-gray-200",
                                          href: StudentTopNav__NavLink.url(link)
                                        }, StudentTopNav__NavLink.title(link)));
                        }), links)));
  } else {
    return null;
  }
}

function StudentTopNav__DropDown(Props) {
  var links = Props.links;
  var match = React.useState(function () {
        return false;
      });
  var setLinksVisible = match[1];
  if (links) {
    return React.createElement("div", {
                key: "more-links",
                className: "ml-6 font-semibold text-sm cursor-pointer relative text-black",
                title: "Show more links",
                onClick: (function (param) {
                    return Curry._1(setLinksVisible, (function (linksVisible) {
                                  return !linksVisible;
                                }));
                  })
              }, React.createElement("span", undefined, "More"), React.createElement("i", {
                    className: "fas fa-caret-down ml-1"
                  }), additionalLinks(match[0], links));
  } else {
    return null;
  }
}

var make = StudentTopNav__DropDown;

exports.str = str;
exports.handleToggle = handleToggle;
exports.additionalLinks = additionalLinks;
exports.make = make;
/* react Not a pure module */
